import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {CartItemContextSource} from '@spartacus/cart/base/components';
import {CartItemContext} from '@spartacus/cart/base/root';
import {Price} from '@spartacus/core';
import {filter} from 'rxjs';
import {EbAnalyticsService} from "../../../analytics/services/facades/eb-analytics.service";
import {EbCartItemComponent} from '../../../cart/components/cart-item/eb-cart-item.component';
import {EbOrderEntry} from '../../../cart/interface/eb-order-entry.interface';
import {EbActiveCartService} from "../../../cart/services/eb-active-cart.service";
import {EbProductTypeEnum} from "../../../product/interfaces/eb-product.interface";
import {EbAvailabilityService} from '../../../product/services/facades/eb-availability.service';

@Component({
    selector: 'eb-favorites-item',
    templateUrl: './eb-favorites-item.component.html',
    styleUrls: ['./eb-favorites-item.component.scss'],
    providers: [
        CartItemContextSource,
        { provide: CartItemContext, useExisting: CartItemContextSource }
    ],
    standalone: false
})
export class EbFavoritesItemComponent extends EbCartItemComponent implements OnInit {
  constructor(
    cartItemContextSource: CartItemContextSource,
    protected availabilityService: EbAvailabilityService,
    protected analyticsService : EbAnalyticsService,
    protected cd: ChangeDetectorRef,
    protected activeCartService: EbActiveCartService,
) {
    super(cartItemContextSource, availabilityService,analyticsService, cd, activeCartService)
  }

  isEditMode = false
  @Output() itemSelected = new EventEmitter()
  @Output() removeSelectedItem = new EventEmitter()
  @Output() editCommentOnEntry = new EventEmitter()
  @ViewChild('entryComment') comment

  ngOnInit() {
    if (this.shouldUpdateAvailability()) {
      this.updateAvailability()
    } else if (!this.item?.product.orderable) {
      this.priceLoading = false
    }
    this.pushMatomoEvents()
  }

  onItemSelectChange(item: EbOrderEntry, isChecked: boolean) {
    item.isSelected = isChecked
    this.itemSelected.emit(item)
  }

  removeFavoritesItem(productCode: string): void {
    this.removeSelectedItem.emit(productCode)
  }

  updateCommentOnEntry(item: EbOrderEntry): void {
    this.editCommentOnEntry.emit({
      entryNumber: item.entryNumber,
      comment: this.comment.nativeElement.value
    })
  }

  deleteCommentOnEntry(item: EbOrderEntry): void {
    item.comment = ''
    this.comment.nativeElement.value = ''
  }

  toggleEditableState() {
    this.isEditMode = !this.isEditMode
  }

  requestRfpEvent() {
    this.analyticsService.requestForQuotation("Favorites")
  }

  /** push matomo track events for variant product in the favorite list page **/
  private pushMatomoEvents() {
    this.priceItem$?.pipe(
      filter(priceItem => this.item?.product &&
                                this.item?.product.ebProductType === EbProductTypeEnum.VARIANT &&
                                this.isPriceSectionExists(priceItem) &&
                               !this.priceLoading
      )
    ).subscribe((priceItem) => {
      this.analyticsService.pushViewVariantProductEvents(this.item?.product, priceItem?.value)
    })
  }

  private isPriceSectionExists(priceItem:Price) {
    return priceItem?.value > 0 || this.hasSuccessor(this.item?.product);
  }
}
